import * as actionTypes from './actionTypes';
import axios from 'axios';

export const AdminAcceptRejectSuccess = (response) => {
    return({
        type: actionTypes.ADMIN_ACCEPT_REJECT_SUCCESS,
        status: 'true'
    });
}

export const AdminAcceptRejectError = (response) => {
    return({
        type: actionTypes.ADMIN_ACCEPT_REJECT_ERROR,
        status: 'waiting'
    });
}

export const AdminAcceptRejectFalse = (response) => {
    return({
        type: actionTypes.ADMIN_ACCEPT_REJECT_FALSE,
        status: 'false'
    });
}

export const AdminAcceptReject = (caseId, status) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/adminAcceptReject`;
    
    const data = {
        caseId: parseInt(caseId),
        status: status
    };
    console.log('AdminAcceptReject api data: '+JSON.stringify(data))
    return (dispatch) => {
        axios.post(url, {
            ...data
        })
        .then((response) => {
            console.log('AdminAcceptReject: response: '+response)
            console.log('AdminAcceptReject: response: '+response.data)
            console.log('AdminAcceptReject: (response.data == true): '+(response.data == true))
            console.log('AdminAcceptReject: (response.data == true): '+(response.data == false))
            console.log('AdminAcceptReject: (response.data == true): '+(response.data == 'error'))
            if (response.data == true){
                dispatch(AdminAcceptRejectSuccess(response));
                window.location.reload()
            }
            else if (response.data == 'error'){
                dispatch(AdminAcceptRejectError(response));
                window.location.reload()
            }
            else if (response.data == false){
                dispatch(AdminAcceptRejectFalse(response));
                window.location.reload()
            }
        })
    };
}